import { JobResultingConfigRecord } from "common/records/JobResultingConfig";
import { RootState } from "common/reducers";
import { Map } from "immutable";
import { createSelector } from "reselect";

/**
 * Gets the job resulting config Record
 *
 * @param {RootState} state the RootState
 * @returns {JobResultingConfigRecord | undefined} Job Resulting Config
 */
export const jobResultingConfig = (state: RootState): JobResultingConfigRecord | undefined =>
  state.getIn(["jobResulting", "config"]);

/**
 * Gets the job resulting options from the config.
 *
 * @param {RootState} state the RootState
 * @returns {Map<string, number>} Map containing the option names and their corresponding indices.
 */
export const optionNameToIndex = createSelector([jobResultingConfig], (config) => {
  let map = Map<string, number>();
  config?.get("options")?.forEach((option, index) => {
    map = map.set(option.get("name"), index);
  });
  return map;
});
